import { type AppState } from '../../common/types';

export const getCategoryMenuWidgetData = (state: AppState) => state.categoryMenuWidget;

export const getAllPostsFeedLabel = (state: AppState) =>
  state.tpaSettings.settings?.allPostsFeedLabel;
